import {configureRolloutId} from '@smartmixin/core';

export const INSTALL_ID_STORAGE_KEY = 'smartmixin.installId';

/**
 * A random id kept in this browser, used only to bucket gradual rollouts
 * (#379) and never sent anywhere. The webapp has no device id and must not
 * send one: the backend scopes signed-out alerts and anonymous premium by
 * X-Device-Id. `null` when storage or `crypto.randomUUID` is unavailable
 * (private mode, an insecure origin): the browser is then in no rollout.
 */
export const getInstallId = (): string | null => {
  try {
    const stored = window.localStorage.getItem(INSTALL_ID_STORAGE_KEY);
    if (stored) {
      return stored;
    }
    const id = window.crypto.randomUUID();
    window.localStorage.setItem(INSTALL_ID_STORAGE_KEY, id);
    return id;
  } catch {
    return null;
  }
};

/** Bucket this browser's rollouts by its install id. Call at startup. */
export const configureRolloutFromInstallId = () => {
  configureRolloutId(getInstallId());
};
